import client from "./client";
export const getCommunities = ({ limit, excludeJoined } = {}) => {
  const params = new URLSearchParams();
  if (limit) params.set("limit", limit);
  if (excludeJoined) params.set("excludeJoined", "true");
  const query = params.toString();
  return client.get(`/communities${query ? `?${query}` : ""}`);
};
export const getCommunity = (id) => client.get(`/communities/${id}`);
export const createCommunity = (formData) => client.post("/communities/create", formData);
export const updateCommunity = (id, formData) => client.put(`/communities/update/${id}`, formData);
export const deleteCommunity = (id) => client.delete(`/communities/delete/${id}`);
export const getCommunityMembers = (id) => client.get(`/communities/members/${id}`);
export const removeMemberFromCommunity = (communityId, userId) => client.delete(`/communities/${communityId}/members/${userId}`);
export const joinCommunity = (userId, communityId) => client.post(`/users/addtocommunity/${userId}/${communityId}`);
export const leaveCommunity = (userId, communityId) => client.post(`/users/leavecommunity/${userId}/${communityId}`);
export const getUserCommunities = (userId) => client.get(`/users/communities/${userId}`);
